import { useMemo, useState } from 'react'

type State = 'idle' | 'loading' | 'success' | 'error'

export default function useRequestState(initialState: State = 'idle') {
  const [state, setState] = useState<State>(initialState)

  const isLoading = useMemo(() => state === 'loading', [state])
  const isSuccess = useMemo(() => state === 'success', [state])
  const isError = useMemo(() => state === 'error', [state])

  return { setState, isLoading, isSuccess, isError, state }
}
